import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "body-2" }
const _hoisted_2 = { class: "body-2" }
const _hoisted_3 = { class: "body-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { class: "body-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}
const _hoisted_7 = { class: "body-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { class: "body-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-red"
}
const _hoisted_11 = { class: "body-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-red"
}
const _hoisted_13 = { class: "body-2" }
const _hoisted_14 = {
  key: 1,
  class: "text-red"
}
const _hoisted_15 = {
  key: 2,
  class: "text-red"
}
const _hoisted_16 = {
  key: 3,
  class: "text-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(_component_v_container, { fill: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: _ctx.getSearchFieldCols }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  placeholder: "Rechercher",
                  label: _ctx.searchLabel,
                  clearable: "",
                  "append-inner-icon": "$search",
                  "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = '')),
                  autofocus: true,
                  "data-cy": "companiesTable-search",
                  id: "CompanyTable_search-field",
                  onKeydown: _withKeys(_ctx.focusOnFirstSupplier, ["tab"])
                }, null, 8, ["modelValue", "label", "onKeydown"])
              ]),
              _: 1
            }, 8, ["cols"]),
            (_ctx.showImport)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "2",
                  class: "pl-2 align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      block: "",
                      onClick: _ctx.importCompanies
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" Importer ")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: _ctx.getTabsCols }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
                  class: "tab_budget_form_mobile"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTabs, (tab) => {
                      return (_openBlock(), _createBlock(_component_v_tab, {
                        key: tab.value,
                        value: tab.value,
                        "data-cy": tab.dataCy,
                        ripple: "",
                        onClick: ($event: any) => (tab.hasClick ? _ctx.emptyMergingList() : null)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "data-cy", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["cols"]),
            (_ctx.activeTab !== 'showGenericCompany')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "1",
                  class: "pl-2 align-center text-right"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_btn_icon, {
                      icon: _ctx.inactiveCompaniesIcon,
                      onClick: _withModifiers(_ctx.toggleShowInactive, ["stop"])
                    }, null, 8, ["icon", "onClick"]), [
                      [_directive_tooltip, _ctx.inactiveCompaniesTooltip, "left"]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.activeTab) = $event))
        }, {
          default: _withCtx(() => [
            (_ctx.showGenericCompany)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 0,
                  value: "showGenericCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                )
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genericCompanies, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: company.id,
                                    onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"]),
                                    class: "my-1",
                                    "data-cy": 'CompaniesTable-name-' + company.id,
                                    lines: "one",
                                    border: "",
                                    rounded: "xl"
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_btn_next, { tabindex: "-1" })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("div", _hoisted_1, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "data-cy"]))
                                }), 128)),
                                (_ctx.loadingGenericDb)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showConsumerCompany && _ctx.consumerCompany)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: "showConsumerCompany",
                  value: "showConsumerCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                )
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onAdd(_ctx.consumerCompany)), ["stop"])),
                                  class: "my-1",
                                  lines: "one",
                                  border: "",
                                  rounded: "xl"
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, { icon: "$fa-star" }),
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode(" Particulier ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.loadingConsumerDb)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showCustomerCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: "showCustomerCompany",
                  value: "showCustomerCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "mb-2 d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectAllCompany(_ctx.customerCompanies))),
                                      "data-cy": "UserEdition-allCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createTextVNode(" Sélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      rounded: "xl",
                                      elevation: "0",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.diselectAllCompany())),
                                      "data-cy": "UserEdition-notAllCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createTextVNode(" Désélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list, {
                              modelValue: _ctx.selectedCompanies,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                              multiple: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_virtual_scroll, {
                                  items: _ctx.customerCompanies,
                                  "item-height": 65,
                                  height: "500"
                                }, {
                                  default: _withCtx(({ item: company }) => [
                                    (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: company.id,
                                      value: company.id,
                                      class: "my-1",
                                      "data-cy": "companiesTable-customerCompany",
                                      lines: "one",
                                      border: "",
                                      rounded: "xl",
                                      onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"])
                                    }, {
                                      prepend: _withCtx(() => [
                                        (_ctx.showSelectMergeCompanies)
                                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                              key: 0,
                                              modelValue: _ctx.selectedCompanies,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                                              onClick: _withModifiers(($event: any) => (_ctx.companiesToMerge(company.id)), ["stop"]),
                                              value: _ctx.isSelectedCompany(company.id)
                                            }, null, 8, ["modelValue", "onClick", "value"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      append: _withCtx(() => [
                                        (_ctx.isFavOf(company.thirdPartyCompanyData))
                                          ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                              key: 0,
                                              color: "primary",
                                              icon: "$fa-star",
                                              onClick: _withModifiers(($event: any) => (_ctx.addToFav(company)), ["stop"])
                                            }, null, 8, ["onClick"]))
                                          : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                              key: 1,
                                              icon: "$far-fa-star",
                                              onClick: _withModifiers(($event: any) => (_ctx.addToFav(company)), ["stop"])
                                            }, null, 8, ["onClick"])),
                                        _createVNode(_component_v_btn_next, {
                                          tabindex: "-1",
                                          onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"])
                                        }, null, 8, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"500px"} }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("div", _hoisted_2, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "onClick"]))
                                  ]),
                                  _: 1
                                }, 8, ["items"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showSupplierCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 3,
                  value: "showSupplierCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "mb-2 d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.selectAllCompany(_ctx.supplierCompanies)), ["stop"])),
                                      "data-cy": "UserEdition-allCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode(" Sélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      elevation: "0",
                                      rounded: "xl",
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.diselectAllCompany()), ["stop"])),
                                      "data-cy": "UserEdition-notAllCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                                        _createTextVNode(" Désélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                )
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSupplierCompanies, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: company.id,
                                    class: "my-1",
                                    onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"]),
                                    "data-cy": `CompaniesTable-${company.id}`,
                                    border: "",
                                    lines: "one",
                                    rounded: "xl"
                                  }, {
                                    prepend: _withCtx(() => [
                                      (_ctx.showSelectMergeCompanies)
                                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                            key: 0,
                                            modelValue: _ctx.selectedCompanies,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                                            onClick: _withModifiers(($event: any) => (_ctx.companiesToMerge(company.id)), ["stop"]),
                                            value: _ctx.isSelectedCompany(company.id)
                                          }, null, 8, ["modelValue", "onClick", "value"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    append: _withCtx(() => [
                                      (
                                                company.thirdPartyCompanyData &&
                                                (company.thirdPartyCompanyData as any)?.isFavorite
                                            )
                                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                            key: 0,
                                            icon: "$fa-star"
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                            key: 1,
                                            icon: "$fa-star"
                                          })),
                                      _createVNode(_component_v_btn_next, { tabindex: "-1" })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("div", _hoisted_3, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                      (company.isActive === false)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Cette société n'est plus active "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "data-cy"]))
                                }), 128)),
                                (_ctx.supplierCompaniesLoading)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showBobbeeCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 4,
                  value: "showBobbeeCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "mb-2 d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      dark: "",
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      size: "small",
                                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.selectAllCompany(_ctx.bobbeeCompanies)), ["stop"])),
                                      "data-cy": "UserEdition-allCompanies"
                                    }, {
                                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                                        _createTextVNode(" Sélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      dark: "",
                                      elevation: "0",
                                      rounded: "xl",
                                      size: "small",
                                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.diselectAllCompany()), ["stop"])),
                                      "data-cy": "UserEdition-notAllCompanies"
                                    }, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode(" Désélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list, {
                              "two-line": "",
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.xs
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                )
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBobbeeCompanies, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: company.id,
                                    class: "my-1",
                                    onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"]),
                                    "data-cy": `CompaniesTable-${company.id}`,
                                    border: "",
                                    rounded: "xl"
                                  }, {
                                    prepend: _withCtx(() => [
                                      (_ctx.showSelectMergeCompanies)
                                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                            key: 0,
                                            modelValue: _ctx.selectedCompanies,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                                            value: _ctx.isSelectedCompany(company.id),
                                            color: "primary",
                                            onClick: _withModifiers(($event: any) => (_ctx.companiesToMerge(company.id)), ["stop"])
                                          }, null, 8, ["modelValue", "value", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_btn_next, { tabindex: "-1" })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("div", _hoisted_5, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                      (company.isActive === false)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Cette société n'est plus active "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "data-cy"]))
                                }), 128)),
                                (_ctx.bobbeeCompaniesLoading)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showOrphelinCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 5,
                  value: "showOrphelinCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "mb-2 d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.selectAllCompany(_ctx.orphelinCompanies)), ["stop"])),
                                      "data-cy": "UserEdition-allCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                                        _createTextVNode(" Sélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.showSelectMergeCompanies)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      elevation: "0",
                                      rounded: "xl",
                                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.diselectAllCompany()), ["stop"])),
                                      "data-cy": "UserEdition-notAllCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode(" Désélectionner toutes les sociétés ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                ),
                              lines: "one"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrphelinCompanies, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: company.id,
                                    class: "my-1",
                                    onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"]),
                                    border: "",
                                    rounded: "xl"
                                  }, {
                                    prepend: _withCtx(() => [
                                      (_ctx.showSelectMergeCompanies)
                                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                            key: 0,
                                            modelValue: _ctx.selectedCompanies,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                                            value: _ctx.isSelectedCompany(company.id),
                                            color: "primary",
                                            onClick: _withModifiers(($event: any) => (_ctx.companiesToMerge(company.id)), ["stop"])
                                          }, null, 8, ["modelValue", "value", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_btn_trash, {
                                        modelValue: company.id,
                                        "onUpdate:modelValue": ($event: any) => ((company.id) = $event),
                                        onClick: _withModifiers(($event: any) => (_ctx.confirmToDeleteOrphelin(company)), ["stop"])
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("div", _hoisted_7, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                      (company.isActive === false)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Cette société n'est plus active "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128)),
                                (_ctx.orphelinCompaniesLoading)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showExistingCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 6,
                  value: "showExistingCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                ),
                              lines: "one"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsDb, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: company.id,
                                    onClick: _withModifiers(($event: any) => (_ctx.onAdd(company)), ["stop"]),
                                    class: "my-1",
                                    "data-cy": 'CompaniesTable-' + company.siret,
                                    rounded: "xl",
                                    border: ""
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_btn_next, { tabindex: "-1" })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("div", _hoisted_9, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                      (company.isActive === false)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Cette société n'est plus active "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "data-cy"]))
                                }), 128)),
                                (_ctx.loadingCompaniesDb || _ctx.companiesCount_db > _ctx.items_db.length)
                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    })), [
                                      [_directive_intersect, _ctx.paginationDBIntersecting]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.foundCompanies && _ctx.foundCompanies.length)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 7,
                  value: "showFoundCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          style: _normalizeStyle(
                                _ctx.$vuetify.display.mobile
                                    ? 'max-height: 50vh; overflow: auto'
                                    : `max-height: ${_ctx.listHeight}; overflow: auto`
                            )
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foundCompanies, (metaCompany, index) => {
                              return (_openBlock(), _createBlock(_component_v_list, {
                                key: index,
                                subheader: "",
                                lines: "one"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_subheader, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(metaCompany.rechercheAssociée.join(" ")), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCompanies(metaCompany.companies), (company) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      class: "my-1",
                                      key: company.siret,
                                      onClick: _withModifiers(($event: any) => (
                                        company.isActive !== false ? _ctx.onAdd(company) : () => {}
                                    ), ["stop"]),
                                      rounded: "xl",
                                      border: ""
                                    }, {
                                      append: _withCtx(() => [
                                        (company.id)
                                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                _createTextVNode("$storage")
                                              ])),
                                              _: 1
                                            }))
                                          : (company.isActive === false)
                                            ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                                  _createTextVNode("$highlight_off")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                  _createTextVNode("$fiber_new")
                                                ])),
                                                _: 1
                                              }))
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                        (company.isActive === false)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Cette société n'est plus active "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showNewCompanies)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 8,
                  value: "showNewCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              style: _normalizeStyle(
                                    _ctx.$vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${_ctx.listHeight}; overflow: auto`
                                ),
                              lines: "one"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.search && _ctx.search.length)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      class: "my-1",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createNewMissingCompany())),
                                      "data-cy": "companiesTable-addMissingCompany",
                                      rounded: "xl",
                                      border: ""
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$add",
                                          color: "secondary",
                                          dark: "",
                                          size: "small",
                                          class: "elevation-0"
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.search), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                                            _createTextVNode("La sociéte n'est pas dans la liste. J'en crée une")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsApi, (company) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    class: "my-1",
                                    key: company.siret,
                                    onClick: _withModifiers(($event: any) => (_ctx.isSelectable(company) ? _ctx.onAdd(company) : () => {}), ["stop"]),
                                    rounded: "xl",
                                    border: ""
                                  }, {
                                    append: _withCtx(() => [
                                      (
                                                company.isClientOfAccountingFirm &&
                                                !_ctx.canSelectCompaniesWithAccountingCompany
                                            )
                                        ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                                              _createTextVNode("$highlight_off")
                                            ])),
                                            _: 1
                                          }))
                                        : (company.id)
                                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                _createTextVNode("$storage")
                                              ])),
                                              _: 1
                                            }))
                                          : (company.isActive === false)
                                            ? (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                                default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                  _createTextVNode("$highlight_off")
                                                ])),
                                                _: 1
                                              }))
                                            : (company.archivingDate)
                                              ? (_openBlock(), _createBlock(_component_v_icon, { key: 3 }, {
                                                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                    _createTextVNode("$highlight_off")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_icon, { key: 4 }, {
                                                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                    _createTextVNode("$fiber_new")
                                                  ])),
                                                  _: 1
                                                }))
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(company)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getSiretValue(company.siret)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (company.archivingDate)
                                        ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString("Archivé le : " + _ctx.getArchivingDate(company.archivingDate)), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_13, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1),
                                      (company.isActive === false)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Cette société n'est plus active "))
                                        : _createCommentVNode("", true),
                                      (
                                            company.isClientOfAccountingFirm &&
                                            !_ctx.canSelectCompaniesWithAccountingCompany
                                        )
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Cette société est déjà présente dans votre liste de dossiers. "))
                                        : _createCommentVNode("", true),
                                      (company.archivingDate && _ctx.isCompanyArchived)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Cette société est déjà présente dans votre liste de dossiers archivés. "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128)),
                                (
                                        _ctx.loadingCompaniesApi ||
                                        _ctx.loadingArchivedClientCompanies ||
                                        _ctx.companiesCount_api > _ctx.items_api.length
                                    )
                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_skeleton_loader, {
                                          ref: "skeleton",
                                          type: "list-item-three-line"
                                        }, null, 512)
                                      ]),
                                      _: 1
                                    })), [
                                      [_directive_intersect, _ctx.paginationAPIIntersecting]
                                    ])
                                  : _createCommentVNode("", true),
                                (!_ctx.search || !_ctx.search.length)
                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      class: "my-1",
                                      style: {"background":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { class: "py-0" }, {
                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                            _createTextVNode(" Faites une recherche de sociétés, les résultats apparaîtront ici ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })), [
                                      [_directive_intersect, _ctx.paginationAPIIntersecting]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["style"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.confirmDeleteDialog,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.confirmDeleteDialog) = $event)),
        title: "Suppression Société",
        onValid: _cache[20] || (_cache[20] = ($event: any) => {
                _ctx.deleteOrphelin(_ctx.toDeleteCompany.id);
                _ctx.confirmDeleteDialog = false;
            }),
        "max-width": "40vw"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h4", null, "Voulez-vous supprimer la société " + _toDisplayString(_ctx.toDeleteCompany.name) + " ?", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.multiDeleteDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.multiDeleteDialog,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.multiDeleteDialog) = $event)),
            title: "Suppression Société",
            onValid: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteOrphelinCompanies())),
            "max-width": "40vw"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, "Voulez-vous supprimer " + _toDisplayString(_ctx.selectedCompanies.length) + " société(s) ?", 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}